import { FOCUS } from '@/components/shell/focus'

// Classes shared by the signed-out pages (Login, Signup, Reset password, Locked out boards), so the
// links, alert boxes and footer links read the same everywhere. Kept in a .ts file under src/ so
// Tailwind still sees the full class names.

/** An inline text link or link-styled button: accent, 500, no underline. */
export const AUTH_LINK = [FOCUS, 'rounded font-medium text-accent no-underline hover:text-accent-hover']

/** The red box for a failed request (put `role="alert"` on it). */
export const AUTH_ERROR_BOX = 'rounded-[10px] bg-danger-tint px-3.5 py-3 text-[13.5px] text-danger-text'

/** The green box for a done request (put `role="status"` on it). */
export const AUTH_SUCCESS_BOX = 'rounded-[10px] bg-success-tint px-3.5 py-3 text-[13.5px] text-success-text'

/** A link in the shell's footer row: 44px tall below 1024px (touch), plain text height from there. */
export const AUTH_FOOTER_LINK = [
  FOCUS,
  'inline-flex min-h-11 items-center rounded text-ink-3 underline underline-offset-2 hover:text-ink lg:min-h-0',
]
